// 这里 特指支付宝小程序，后面如果需要拓展什么阿里云小程序、淘宝小程序之类的，就自己新建
import service from './miniProgram';

const alipay = service;

export default alipay;